"use client";
import * as React from "react";
const SvgChevronLeftRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 8 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M7 .7a1 1 0 0 0-1.41 0L1 5.3a1 1 0 0 0 0 1.4l4.59 4.6A1 1 0 1 0 7 9.88L3.12 6 7 2.12A1 1 0 0 0 7 .7" }));
export {
  SvgChevronLeftRound as default
};
